import { gql } from '@apollo/client'

export const EDIT_USER = gql`
  mutation EditUser($user: UpdateUserInput!) {
    updateUserV2(input: $user)
  }
`

export const RESET_USER_PASSWORD = gql`
  mutation ResetUserPassword($input: ResetUserPasswordInput!) {
    resetUserPassword(input: $input)
  }
`
